
import { ComponentPropsWithoutRef } from "react";
import { FileWithPath } from "react-dropzone";
import { DialogWithHeader } from "@components/dialog";
import { DefaultDropzone } from "@components/form";
import { MAX_DONATION_FILE_PROOF_COUNT, MAX_DONATION_FILE_PROOF_SIZE } from "../donation.config";
import { SolidButton } from "@components/form/button/SolidButton";
import { useTranslation } from "react-i18next";


interface SelectAnonymousDonationFileProps extends Omit<ComponentPropsWithoutRef<typeof DialogWithHeader>, "title">{
  filesValue: FileWithPath[];
  setFilesValue: React.Dispatch<React.SetStateAction<FileWithPath[]>>;
  getSendFileModalOpen: ()=> any;
}


export function SelectAnonymousDonationFile({
  filesValue, 
  setFilesValue, 
  isOpen, 
  getSendFileModalOpen, 
  modalAccess, /* ...props */
}: SelectAnonymousDonationFileProps){

    const {t} = useTranslation();

  function handleSelectFile (e: React.MouseEvent<HTMLFormElement, MouseEvent>){
    e.preventDefault();
    e.stopPropagation();

    // modalAccess(false);
    getSendFileModalOpen();
  }

  return (
    <DialogWithHeader
      isOpen={isOpen}
      modalAccess={modalAccess}
      title="Upload Sample File"
      className="bg-secondary-base basis-1/3 max-h-[80%] overflow-auto"
    >
      <form 
        className="p-2"
        onSubmit={handleSelectFile}  
        data-testid="donation-sendAnonymousDonationFile-selectAnonymousDonation-form"
      >
        <DefaultDropzone
          filesValue={filesValue}
          setFilesValue={setFilesValue}
          whenDragText={t("features.donation.select_anonymous_donation.select_file.when_drag")}
          whenIdleText={
            t("features.donation.select_anonymous_donation.select_file.when_idle")
          }
          maxCount={MAX_DONATION_FILE_PROOF_COUNT} // hanya 1
          maxSize={MAX_DONATION_FILE_PROOF_SIZE} // sekitar 10 mb

          data-testid="donation-sendAnonymousDonationFile-selectAnonymousDonation-proof-input"
        />
        <SolidButton 
           
          variant="success"
          type="submit"
          className="mt-3 block ms-auto"

          data-testid="donation-sendAnonymousDonationFile-selectAnonymousDonation-proof-input"
        >
          Upload
        </SolidButton>
      </form>
    </DialogWithHeader>
  )
}